// Anmeldung mit Kürzel und Passwort (dieselben Zugangsdaten wie im bisherigen IMHO).
import { useEffect, useState, type FormEvent } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router";
import { fehlertext } from "../api/client";
import { Feld, Knopf } from "../bausteine/einfach";
import { PROGRAMMNAME, VERSION } from "../kern/marke";
import { istRahmen } from "../kern/rahmen";
import { anmeldeHinweis, useSitzung } from "../kern/sitzung";
import { OHNE_RAHMEN } from "../navigation/katalog";
import { startseite } from "../navigation/start";

/** Vollbild-Seiten (ZeitApp) liefert der Torweg ohne Rahmen – vom Rahmen aus also ganz neu laden. */
const ohneRahmen = (ziel: string) => istRahmen() && Object.keys(OHNE_RAHMEN).some((p) => ziel === p || ziel.startsWith(`${p}/`)
  || ziel.startsWith(`${p}?`));

export default function Anmelden() {
  const { ich, anmelden } = useSitzung();
  const [parameter] = useSearchParams();
  const navigate = useNavigate();
  const [kuerzel, setKuerzel] = useState("");
  const [passwort, setPasswort] = useState("");
  const [fehler, setFehler] = useState<string | null>(null);
  const [laedt, setLaedt] = useState(false);
  const [hinweis] = useState(() => (ich ? null : anmeldeHinweis()));
  useEffect(() => { if (hinweis) anmeldeHinweis(true); }, [hinweis]);

  const zurueck = parameter.get("zurueck");
  const ziel = (rechte: readonly string[]) => (zurueck && zurueck.startsWith("/") && !zurueck.startsWith("//")
    ? zurueck : startseite(rechte));

  if (ich && ohneRahmen(ziel(ich.rechte))) {
    window.location.replace(ziel(ich.rechte));
    return null;
  }
  if (ich) return <Navigate to={ziel(ich.rechte)} replace />;

  const senden = async (e: FormEvent) => {
    e.preventDefault();
    setFehler(null);
    setLaedt(true);
    try {
      const neu = await anmelden(kuerzel, passwort);
      if (ohneRahmen(ziel(neu.rechte))) window.location.replace(ziel(neu.rechte));
      else navigate(ziel(neu.rechte), { replace: true });
    } catch (ex) {
      setFehler(fehlertext(ex));
      setPasswort("");
    } finally {
      setLaedt(false);
    }
  };

  return (
    <div className="im-root im-anmelden">
      <form className="im-anmelden__karte" onSubmit={senden} noValidate>
        <div className="im-anmelden__marke"><i />{PROGRAMMNAME} <span className="im-nav__version">{VERSION}</span></div>
        <h1 className="im-t-section">Anmelden</h1>
        {hinweis && <p className="im-help" role="status">{hinweis}</p>}
        <Feld label="Kürzel" name="kuerzel" autoComplete="username" autoCapitalize="characters" spellCheck={false}
          value={kuerzel} onChange={(e) => setKuerzel(e.target.value)} required autoFocus />
        <Feld label="Passwort" name="passwort" type="password" autoComplete="current-password" value={passwort}
          onChange={(e) => setPasswort(e.target.value)} required />
        {fehler && <p className="im-help im-help--error" role="alert">{fehler}</p>}
        <Knopf art="haupt" type="submit" laedt={laedt} disabled={!kuerzel || !passwort}>Anmelden</Knopf>
        <p className="im-small">Dieselben Zugangsdaten wie im bisherigen IMHO.</p>
      </form>
    </div>
  );
}
